import React, { useEffect, useState } from 'react';
import axios from 'axios';
import TicketSelect from './Step10_TicketSelect';
import CustomerForm from './Step20_CustomerForm';
import PaymentType from './Step40_PaymentType';
import Summary from './Step30_Summary';
import Confirm from './Step50_Confirm';
import EventSelect from './Step00_EventSelect';
import { api, getEventById } from "ticketino-api-client";
import SeatmapTicketSelect from './Step10_SeatmapTicketSelect';
/* eslint eqeqeq: "off" */

function Home() {

    const htmlElement = document.getElementById("ticketinoShopPlugin");
    const organizerUrl = htmlElement.getAttribute("organizerUrl");
    const languageCodes = [{ language: "de", id: 1 }, { language: "fr", id: 2 }, { language: "en", id: 3 }, { language: "it", id: 4 }]

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    const [ticketTypesInformation, setTicketTypesInformation] = useState();
    const [currentPage, setCurrentPage] = useState(-1);
    const [orderId, setOrderId] = useState(0);
    const [selectedEventId, setSelectedEventId] = useState(0);
    const [selectedSeatmapId, setSelectedSeatmapId] = useState(0);
    const [selectedEventGroupId, setSelectedEventGroupId] = useState(0);
    const [token, setToken] = useState("");
    const [selectedLanguageISO, setSelectedLanguageISO] = useState("de");
    const [selectedLanguageCode, setSelectedLanguageCode] = useState(0);
    const [selectedSeatsInformation, setSelectedSeatsInformation] = useState();

    function changePage(pageNumber) {
        //to go back : negative number
        //to go forward : positive number
        let page = currentPage + pageNumber;
        setCurrentPage(page);
    }

    function changeOrderId(orderId) {
        setOrderId(orderId);
    }

    async function changeEventId(eventId) {
        if (token != "") {
            const theEvent = await getEventById(eventId);
            if (theEvent?.zoneMapId > 0) {
                setSelectedSeatmapId(theEvent.zoneMapId);
            }
            else {
                setSelectedSeatmapId(0);
            }
            setSelectedEventId(eventId);
        }
    }

    function changeLanguage(language) {
        setSelectedLanguageISO(language);
        let languageCode;

        languageCode = languageCodes.find((lang) => lang.language == language).id;
        setSelectedLanguageCode(languageCode);
    }

    function changeTicketTypesInformation(ticketInfos) {
        setTicketTypesInformation(ticketInfos);
    }

    function addScripts() {

        //Adds scrips on the DOM

        var script = document.createElement('script');
        script.src = "https://pay.datatrans.com/upp/payment/js/datatrans-1.0.2.js";
        document.head.appendChild(script);

        var script2 = document.createElement('script');
        script2.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js";
        document.head.appendChild(script2);

        var link = document.createElement('link');
        link.href = `${baseProxyUrl}/getPluginFilesCss`;
        link.rel = "stylesheet";

        document.head.appendChild(link);

        var loadBootstrap = htmlElement.getAttribute("loadBootstrap") ?? true;

        if (loadBootstrap == true || loadBootstrap == "true") {
            var bootstrap = document.createElement('link');
            bootstrap.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
            bootstrap.rel = "stylesheet";
            bootstrap.integrity = "sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN";
            bootstrap.crossOrigin = "anonymous";
            document.head.appendChild(bootstrap);
        }
    }
    function getQueryParamFromParent(paramName) {
        try {

            const parentUrl = window.location.href; // Get the parent website URL

            if (!parentUrl) {
                return null;
            }

            const urlSearchParams = new URL(parentUrl).searchParams;

            // Check if the parameter exists in the URL, return its value or null if not found
            return urlSearchParams.has(paramName) ? urlSearchParams.get(paramName) : null;
        } catch (error) {
            console.error("Error extracting query parameter:", error);
            return null;
        }
    };

    useEffect(() => {

        axios.get(`${baseProxyUrl}/token`).then((result) => {
            setToken(result.data);
        });

        addScripts();

        const languageISO = htmlElement.getAttribute("languageISO");
        const eventGroupId = htmlElement.getAttribute("eventGroupId");
        let confirmedOrderId = getQueryParamFromParent("confirmedOrderId");

        if (languageISO != null || languageISO != undefined) {

            if (languageISO == "en") {
                setSelectedLanguageISO(languageISO);
                setSelectedLanguageCode(3);

            }
            else if (languageISO == "de") {
                setSelectedLanguageISO(languageISO);
                setSelectedLanguageCode(1);

            }
            else if (languageISO == "fr") {
                setSelectedLanguageISO(languageISO);
                setSelectedLanguageCode(2);

            }
            else if (languageISO == "it") {
                setSelectedLanguageISO(languageISO);
                setSelectedLanguageCode(4);
            }
            else {
                setSelectedLanguageCode(1);
                setSelectedLanguageISO("de");
            }
        }
        else {
            setSelectedLanguageCode(1);
            setSelectedLanguageISO("de");
        }

        if (eventGroupId != null || eventGroupId != undefined) {
            if (Number(eventGroupId) > 0) {
                setSelectedEventGroupId(Number(eventGroupId));
                setCurrentPage(0);
            }
        }

        if (confirmedOrderId) {
            axios
                .get(`${baseProxyUrl}/GetConfirmedOrderId/${confirmedOrderId}`)
                .then((res) => {
                    setOrderId(res.data);
                    setCurrentPage(5);
                })
                .catch((error) => console.error(error.response.data));
        }

    }, [])

    useEffect(() => {

        if (token != "") {
            api.defaults.headers.common['Authorization'] = "Bearer " + token;
            api.defaults.baseURL = baseUrl;
        }

        const eventId = htmlElement.getAttribute("eventId");

        if (eventId != null || eventId != undefined) {

            const handleChangeEventId = async () => {
                await changeEventId(Number(eventId) || 0);
            };

            handleChangeEventId();
        }


    }, [token])

    useEffect(() => {

        if (selectedEventId > 0) {

            setCurrentPage(1);
        }

    }, [selectedEventId])

    return (
        <div className="App ticketinoApp ticketino-bootstrap p-3">
            <div id="ticketinoScrollElement" />
            <div className="componentDiv">
                {(currentPage == 0 && token.length > 0) &&
                    <EventSelect
                        changePage={changePage}
                        token={token}
                        eventGroupId={selectedEventGroupId}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        changeEvent={changeEventId}
                        showEventsAsList={htmlElement.getAttribute("showEventsAsList")}
                    />
                }
                {(currentPage == 1 && selectedSeatmapId == 0 && token.length > 0) &&
                    <TicketSelect
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        token={token}
                        orderId={orderId}
                        eventGroupId={selectedEventGroupId}
                        eventId={selectedEventId}
                        selectedTicketTypeIds={htmlElement.getAttribute("ticketIds")}
                        singleTicketAsCB={htmlElement.getAttribute("singleTicketAsCB")}
                        disableTickets={htmlElement.getAttribute("disableTickets")}
                        enableTickets={htmlElement.getAttribute("enableTickets")}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        showTicketDescription={htmlElement.getAttribute("showTicketDescription")}
                        selectedCurrency={htmlElement.getAttribute("currency")}
                        changeTicketTypesInformation={changeTicketTypesInformation}
                        allowUnlockTicketTypes={htmlElement.getAttribute("allowUnlockTicketTypes")}
                        showEventBanner={htmlElement.getAttribute("showEventBanner")}
                        showTicketTypesAsList={htmlElement.getAttribute("showTicketTypesAsList")}
                    />
                }
                {(currentPage == 1 && selectedSeatmapId > 0 && token.length > 0) &&
                    <SeatmapTicketSelect
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        token={token}
                        orderId={orderId}
                        eventGroupId={selectedEventGroupId}
                        selectedSeatmapId={selectedSeatmapId}
                        eventId={selectedEventId}
                        selectedTicketTypeIds={htmlElement.getAttribute("ticketIds")}
                        singleTicketAsCB={htmlElement.getAttribute("singleTicketAsCB")}
                        disableTickets={htmlElement.getAttribute("disableTickets")}
                        enableTickets={htmlElement.getAttribute("enableTickets")}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        showTicketDescription={htmlElement.getAttribute("showTicketDescription")}
                        selectedCurrency={htmlElement.getAttribute("currency")}
                        changeTicketTypesInformation={changeTicketTypesInformation}
                        allowUnlockTicketTypes={htmlElement.getAttribute("allowUnlockTicketTypes")}
                        showEventBanner={htmlElement.getAttribute("showEventBanner")}
                        showTicketTypesAsList={htmlElement.getAttribute("showTicketTypesAsList")}
                    />
                }
                {currentPage == 2 &&
                    <CustomerForm
                        orderId={orderId}
                        token={token}
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        selectedFields={htmlElement.getAttribute("wantedFields")}
                        organizerUrl={organizerUrl}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        selectedSeatmapId={selectedSeatmapId}
                        changeLanguage={changeLanguage}
                        eventId={htmlElement.getAttribute("eventId")}
                        ticketTypesInformation={ticketTypesInformation}
                        showTicketTypesAsList={htmlElement.getAttribute("showTicketTypesAsList")}
                        singleTicketAsCB={htmlElement.getAttribute("singleTicketAsCB")}
                        disableTickets={htmlElement.getAttribute("disableTickets")}
                        enableTickets={htmlElement.getAttribute("enableTickets")}
                        showTicketDescription={htmlElement.getAttribute("showTicketDescription")}
                        changeTicketTypesInformation={changeTicketTypesInformation}
                    />
                }
                {currentPage == 3 &&
                    <Summary
                        orderId={orderId}
                        token={token}
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        eventId={htmlElement.getAttribute("eventId")}
                        selectedFields={htmlElement.getAttribute("wantedFields")}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        ticketTypesInformation={ticketTypesInformation}
                    />
                }
                {currentPage == 4 &&
                    <PaymentType
                        orderId={orderId}
                        token={token}
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        selectedFields={htmlElement.getAttribute("wantedFields")}
                        allowPromtionCode={htmlElement.getAttribute("allowPromotionCode")}
                        organizerUrl={organizerUrl ? organizerUrl : window.location.href}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        allowElectronicPayment={htmlElement.getAttribute("allowElectronicPayment")}
                        allowInsurance={htmlElement.getAttribute("allowInsurance")}
                        selectedCurrency={htmlElement.getAttribute("currency")}
                        ticketTypesInformation={ticketTypesInformation}
                        organizerId={htmlElement.getAttribute("organizerId")}
                    />
                }
                {currentPage == 5 &&
                    <Confirm
                        orderId={orderId}
                        token={token}
                        changePage={changePage}
                        changeOrderId={changeOrderId}
                        eventId={htmlElement.getAttribute("eventId")}
                        languageISO={selectedLanguageISO}
                        languageCode={selectedLanguageCode}
                        changeLanguage={changeLanguage}
                        organizerId={htmlElement.getAttribute("organizerId")}
                    />
                }
            </div>
        </div>
    );
}

export default Home;
